<template>
    <div class="ATabs">
        <div class="ATabs__tab"
             v-for="(tab, key) in tabs"
             :key="key"
             :class="{'ATabs__tab--active': currentTab === key}"
             @click="currentTab = key"
        >
            {{ tab }}
        </div>
    </div>
</template>

<script>
import useTabsValue from "../../composables/useTabsValue";

export default {
    name: "ATabs",
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: [Number, String],
            default: 0,
        }
    },
    setup(props, ctx) {
        const {currentTab} = useTabsValue(props, ctx)

        return {
            currentTab
        }
    }
}
</script>

<style scoped lang="scss">
.ATabs {
    display: flex;
    font-weight: 600;
    font-size: rem(16);
    line-height: 150%;
    width: 100%;
    justify-content: space-between;
    padding-top: $baseSpacing;
    overflow: auto;
    background-color: #fff;

    &__tab {
        border-bottom: 3px solid transparent;
        padding: 0 rem(15) $baseSpacing rem(15);
        cursor: pointer;
        flex: 1 0 auto;
        text-align: center;
        border-bottom-width: 0;


        &--active {
            border-bottom: 3px solid var(--c-primary-200)
        }
    }
}
</style>